export const GET_ALL_COMPANIES = "GET_ALL_COMPANIES";
